import { useTranslation } from 'react-i18next';
import { Grid, Heading, Separator, Stack, Text } from '@shared/ui';

import { ColorSwatch } from './design-tokens/ColorSwatch';
import { RadiusScale } from './design-tokens/RadiusScale';
import { ShadowScale } from './design-tokens/ShadowScale';
import { SpacingScale } from './design-tokens/SpacingScale';
import { TypographyScale } from './design-tokens/TypographyScale';
import { SectionHeader } from './SectionHeader';

export function DesignTokensSection() {
  const { t } = useTranslation();

  return (
    <section id="tokens" className="space-y-8">
      <SectionHeader
        title={t('uiLibrary.tokens.title')}
        description={t('uiLibrary.tokens.description')}
      />

      <Stack gap="lg" className="space-y-6">
        <div className="space-y-3">
          <Heading as="h3" size="xl">
            {t('uiLibrary.tokens.colors.title')}
          </Heading>
          <Text color="muted">{t('uiLibrary.tokens.colors.description')}</Text>
          <Grid cols={1} gap="md" className="sm:grid-cols-2 lg:grid-cols-3">
            <ColorSwatch
              label={t('uiLibrary.tokens.colors.items.background')}
              className="bg-background"
            />
            <ColorSwatch
              label={t('uiLibrary.tokens.colors.items.foreground')}
              className="bg-foreground"
            />
            <ColorSwatch
              label={t('uiLibrary.tokens.colors.items.primary')}
              className="bg-primary"
            />
            <ColorSwatch
              label={t('uiLibrary.tokens.colors.items.secondary')}
              className="bg-secondary"
            />
            <ColorSwatch label={t('uiLibrary.tokens.colors.items.accent')} className="bg-accent" />
            <ColorSwatch
              label={t('uiLibrary.tokens.colors.items.destructive')}
              className="bg-destructive"
            />
            <ColorSwatch label={t('uiLibrary.tokens.colors.items.card')} className="bg-card" />
            <ColorSwatch
              label={t('uiLibrary.tokens.colors.items.popover')}
              className="bg-popover"
            />
            <ColorSwatch label={t('uiLibrary.tokens.colors.items.border')} className="bg-border" />
          </Grid>
        </div>

        <Separator />

        <div className="space-y-3">
          <Heading as="h3" size="xl">
            {t('uiLibrary.tokens.typography.title')}
          </Heading>
          <Text color="muted">{t('uiLibrary.tokens.typography.description')}</Text>
          <TypographyScale />
        </div>

        <Separator />

        <div className="space-y-3">
          <Heading as="h3" size="xl">
            {t('uiLibrary.tokens.dateFormats.title')}
          </Heading>
          <Text color="muted">{t('uiLibrary.tokens.dateFormats.description')}</Text>
          <Stack gap="xs">
            <Text size="sm">{t('uiLibrary.tokens.dateFormats.items.long')}</Text>
            <Text size="sm">{t('uiLibrary.tokens.dateFormats.items.ddmmyyyy')}</Text>
            <Text size="sm">{t('uiLibrary.tokens.dateFormats.items.mmddyyyy')}</Text>
            <Text size="sm">{t('uiLibrary.tokens.dateFormats.items.iso')}</Text>
          </Stack>
        </div>

        <Separator />

        <div className="space-y-3">
          <Heading as="h3" size="xl">
            {t('uiLibrary.tokens.spacing.title')}
          </Heading>
          <Text color="muted">{t('uiLibrary.tokens.spacing.description')}</Text>
          <SpacingScale />
        </div>

        <Separator />

        <div className="space-y-3">
          <Heading as="h3" size="xl">
            {t('uiLibrary.tokens.radius.title')}
          </Heading>
          <Text color="muted">{t('uiLibrary.tokens.radius.description')}</Text>
          <RadiusScale />
        </div>

        <Separator />

        <div className="space-y-3">
          <Heading as="h3" size="xl">
            {t('uiLibrary.tokens.shadows.title')}
          </Heading>
          <Text color="muted">{t('uiLibrary.tokens.shadows.description')}</Text>
          <ShadowScale />
        </div>
      </Stack>
    </section>
  );
}
